import { useUserByProfileId, useCurrentUser } from '@bizzabo/entities';

import { ScheduledMeeting } from '../types';
import { useMeetings } from '../MeetingsTool/MeetingsToolContext';

const useOtherUser = (meeting: ScheduledMeeting) => {
    const { eventId } = useMeetings();

    const {
        data: currentUser,
        isLoading: isLoadingCurrentUser,
        isError: isErrorCurrentUser,
        error: errorCurrentUser,
        isSuccess: isSuccessCurrentUser,
    } = useCurrentUser(eventId);

    const otherParticipant = meeting?.participants?.find(
        participant => participant.userProfileId !== currentUser?.userProfileId
    );

    const {
        data: otherUser,
        isLoading: isLoadingUserByProfileId,
        isError: isErrorUserByProfileId,
        error: errorUserByProfileId,
        isSuccess: isSuccessUserByProfileId,
    } = useUserByProfileId({
        eventId,
        userProfileId: otherParticipant?.userProfileId,
    });

    return {
        data: otherUser,
        isLoading: isLoadingCurrentUser || isLoadingUserByProfileId,
        isError: isErrorCurrentUser || isErrorUserByProfileId,
        error: errorCurrentUser || errorUserByProfileId,
        isSuccess: isSuccessCurrentUser && isSuccessUserByProfileId,
    };
};

export default useOtherUser;
